<template>
  <div class="invoices">
    <div class="main-wrapper">
      <layout-header></layout-header>
      <layout-sidebar></layout-sidebar>
      <!-- Page Wrapper -->
      <div class="page-wrapper">
        <!-- Page Content -->
        <div class="content container-fluid">
          <!-- Page Header -->
          <div class="page-header">
            <div class="row align-items-center">
              <div class="col">
                <h3 class="page-title">Agent Statistics</h3>
                <ul class="breadcrumb">
                  <li class="breadcrumb-item">
                    <router-link to="/index">Dashboard</router-link>
                  </li>
                  <li class="breadcrumb-item">
                    <router-link to="/agent/list">Agents</router-link>
                  </li>
                  <li class="breadcrumb-item active">Statistics</li>
                </ul>
              </div>
            </div>
          </div>
          <!-- /Page Header -->

          <!-- Search Filter -->
          <div class="row filter-row">
            <div class="col-sm-6 col-md-3">
              <div class="form-group form-focus">
                <input
                  class="form-control floating"
                  v-model="serverParams.columnFilters.period"
                  type="month"
                />
                <label class="focus-label">Period</label>
              </div>
            </div>
            <div class="col-sm-6 col-md-3">
              <div class="form-group form-focus">
                <input
                  class="form-control floating"
                  v-model="serverParams.columnFilters.agent_id"
                  type="text"
                />
                <label class="focus-label">Agent ID</label>
              </div>
            </div>

            <div class="col-sm-6 col-md-3">
              <a
                href="javascript:void(0)"
                @click.prevent="searchData"
                class="btn btn-success btn-block"
              >Search</a>
            </div>
          </div>
          <!-- /Search Filter -->
          <div class="row">
            <div class="col-md-12">
              <div class="table-responsive">
                <table class="table table-striped table-bordered custom-table mb-0">
                  <thead>
                    <tr>
                      <th rowspan="2">#</th>
                      <th class="text-center" rowspan="2">Agent</th>
                      <th class="text-center" colspan="2">Read/Open</th>
                      <th class="text-center" colspan="2">Response</th>
                      <th class="text-center" colspan="2">Resolve</th>
                    </tr>
                    <tr>
                      <th class="text-center">Total</th>
                      <th class="text-center">Time</th>
                      <th class="text-center">Total</th>
                      <th class="text-center">Time</th>
                      <th class="text-center">Total</th>
                      <th class="text-center">Time</th>
                    </tr>
                  </thead>
                  <tbody>
                    <template v-if="loading">
                      <tr>
                        <td colspan="8">
                          <Skeleton :count="1" />
                        </td>
                      </tr>
                    </template>
                    <template v-if="rows.length">
                      <tr v-for="(row,index) in rows" :key="index">
                        <td>{{row.number}}</td>
                        <td>{{row.first_name}} {{row.last_name}}</td>
                        <td class="text-right">{{row.num_read}}</td>
                        <td
                          class="text-left text-wrap"
                        >{{calculateSeconds(row.duration_read/row.num_read)}}</td>

                        <td class="text-right">{{row.num_response}}</td>
                        <td
                          class="text-left"
                        >{{calculateSeconds(row.duration_response/row.num_response)}}</td>

                        <td class="text-right">{{row.num_resolve}}</td>
                        <td
                          class="text-left"
                        >{{calculateSeconds(row.duration_resolve/row.num_resolve)}}</td>
                      </tr>
                    </template>
                    <template v-else-if="rows.length<1 && !loading">
                      <tr>
                        <td colspan="8" class="text-center">-empty-</td>
                      </tr>
                    </template>
                    <!-- <tr>
                      <td>1</td>
                      <td>
                        <router-link to="/invoiceview">#INV-0001</router-link>
                      </td>
                      <td>Global Technologies</td>
                      <td>11 Mar 2019</td>
                      <td>17 Mar 2019</td>
                      <td>$2099</td>
                      <td>
                        <span class="badge bg-inverse-success">Paid</span>
                      </td>
                      <td class="text-right">
                        <div class="dropdown dropdown-action">
                          <a
                            href="#"
                            class="action-icon dropdown-toggle"
                            data-toggle="dropdown"
                            aria-expanded="false"
                          >
                            <i class="material-icons">more_vert</i>
                          </a>
                          <div class="dropdown-menu dropdown-menu-right">
                            <router-link to="/editinvoice" class="dropdown-item">
                              <i class="fa fa-pencil m-r-5"></i>Edit
                            </router-link>
                            <router-link to="/invoiceview" class="dropdown-item">
                              <i class="fa fa-eye m-r-5"></i>View
                            </router-link>
                            <a class="dropdown-item" href="#">
                              <i class="fa fa-file-pdf-o m-r-5"></i> Download
                            </a>
                            <a class="dropdown-item" href="#">
                              <i class="fa fa-trash-o m-r-5"></i> Delete
                            </a>
                          </div>
                        </div>
                      </td>
                    </tr>-->
                  </tbody>
                </table>
              </div>
            </div>
          </div>
          <div class="row">
            <div class="col-sm-12 col-md-6">
              <span class="footer__row-count__label">Displaying</span>
              <select
                @change="onPerPageChange(serverParams.perPage)"
                autocomplete="off"
                name="perPageSelect"
                v-model="serverParams.perPage"
                style="width: 100px;"
                class="select-to-paginasi"
              >
                <option value="10">10 / page</option>
                <option value="20">20 / page</option>
                <option value="30">30 / page</option>
                <option value="40">40 / page</option>
                <option value="50">50 / page</option>
              </select>
              <span class="footer__row-count__label">of {{ totalRecords }} total records</span>
            </div>
            <div class="col-sm-12 col-md-6 text-right">
              <a
                href="javascript:void(0)"
                @click="onPrevChange(parseInt(currentPage))"
                tabindex="0"
                class="btn"
                :class="{ disabled: parseInt(currentPage) - 1 <= 0 }"
              >
                <span class="chevron left"></span>
                <span>Prev</span>
              </a>
              page
              <input
                style="width:100px;"
                min="1"
                type="number"
                v-model="currentPage"
                @keyup.enter="onPageChange(parseInt(currentPage))"
                class
              />
              of {{ Math.ceil(totalRecords / serverParams.perPage) }}
              <a
                href="javascript:void(0)"
                @click="onNextChange(parseInt(currentPage))"
                tabindex="0"
                class="footer__navigation__page-btn"
                :class="'btn '+{
                    disabled:
                      parseInt(currentPage) + 1 >
                      Math.ceil(totalRecords / serverParams.perPage)
                  }"
              >
                <span>Next</span>
                <span class="chevron right"></span>
              </a>
            </div>
          </div>
        </div>
        <!-- /Page Content -->
      </div>
      <!-- /Page Wrapper -->
    </div>
  </div>
</template>

<script>
import {
  formatLocalDate,
  nFormatter,
  getCurrentMonth,
  formatDate,
  calculateSeconds
} from "@/utils/helper";
import { Skeleton } from "vue-loading-skeleton";

import LayoutHeader from "@/components/layouts/Header.vue";
import LayoutSidebar from "@/components/layouts/Sidebar.vue";
export default {
  components: {
    LayoutHeader,
    LayoutSidebar,
    Skeleton
  },
  data() {
    return {
      loading: false,
      rows: [],
      totalRecords: 0,
      currentPage: 1,
      rowPage: 1,
      serverParams: {
        columnFilters: {
          period: this.getCurrentMonth(),
          agent_id: ""
        },
        page: 1,
        perPage: 20 // perPage
      }
    };
    //  isactive : true
  },
  created() {
    // console.log(this.$route.query.agent_id)
    if (this.$route.query.agent_id) {
      this.serverParams.columnFilters.agent_id = this.$route.query.agent_id;
    }
    this.loadItems();
    this.currentPage = this.serverParams.page;
  },
  methods: {
    calculateSeconds(value) {
      return calculateSeconds(value);
    },
    async setResolve(roomId) {
      await this.$fire({
        title: "Are you sure you will continue this action?",
        showDenyButton: true,
        showCancelButton: true,
        confirmButtonText: `Yes`,
        denyButtonText: `Cancel`
      }).then(async r => {
        if (typeof r.value != "undefined" && r.value == true) {
          await this.$store
            .dispatch("omniroom/setResolve", roomId) // sesuai kan dengan method di API
            .then(response => {
              this.searchData();
              this.$fire({
                title: "Success",
                text: response["msg"],
                type: "success",
                timer: 2000
              });
            });
          // .catch(error => {
          //   this.$fire({
          //     title: "Error",
          //     text: error.response.data.msg,
          //     type: "error",
          //     timer: 2000
          //   });
          //   console.log(error);
          // });
        }
      });
    },
    formatLocalDate(value) {
      return formatLocalDate(value);
    },
    updateParams(newProps) {
      // console.log("newprops", newProps);
      this.serverParams = Object.assign({}, this.serverParams, newProps);
    },
    async onPageChange(page) {
      await this.updateParams({ page: page });
      this.currentPage = page;
      await this.loadItems();
    },
    async onNextChange(page) {
      if (
        page + 1 <=
        Math.ceil(this.totalRecords / this.serverParams.perPage)
      ) {
        await this.updateParams({ page: page + 1 });
        this.currentPage = page + 1;
        await this.loadItems();
      }
    },
    async onPrevChange(page) {
      // console.log("this.currentPage:: ", this.currentPage);
      if (this.currentPage == 1) {
        return;
      }
      if (
        page - 1 <=
        Math.ceil(this.totalRecords / this.serverParams.perPage)
      ) {
        await this.updateParams({ page: page - 1 });
        this.currentPage = page - 1;
        await this.loadItems();
      }
    },
    async onPerPageChange(params) {
      await this.updateParams({
        page: this.currentPage,
        perPage: this.serverParams.perPage
      });
      await this.loadItems();
    },
    formatDate(value) {
      return formatDate(value);
    },
    getCurrentMonth() {
      return getCurrentMonth();
    },
    nFormatter(value) {
      return nFormatter(value);
    },
    async searchData() {
      // this.currentPage = await 1;
      // this.serverParams.columnFilters.page = await 1;
      // await this.getListData();

      this.currentPage = 1;
      this.rows = await [];
      this.loading = await true;
      this.totalRecords = await 0;
      var params = await { page: this.currentPage };
      await this.updateParams(params);
      await this.loadItems();
      this.loading = await false;
    },
    async loadItems() {
      this.loading = await true;
      this.serverParams.page =
        this.serverParams.page - 1 <= 0
          ? await 0
          : await ((this.serverParams.page - 1) * this.serverParams.perPage);

      await this.$store
        .dispatch("member/monthlyAgentsStatistic", this.serverParams) // sesuai kan dengan method di API
        .then(response => {
          const { data } = response;
          this.totalRecords = data.totalRecords;
          this.rowPage = data.page;
          this.rows = data.data;
          // console.log("rows", this.rows);
          this.loading = false;
        })
        .catch(error => {
          console.log(error);
        });
    }
  },
  mounted() {
    // Date Time Picker

    if ($(".datetimepicker").length > 0) {
      $(".datetimepicker").datetimepicker({
        format: "DD/MM/YYYY",
        icons: {
          up: "fa fa-angle-up",
          down: "fa fa-angle-down",
          next: "fa fa-angle-right",
          previous: "fa fa-angle-left"
        }
      });
    }

    // Select 2
    if ($(".select").length > 0) {
      $(".select").select2({
        minimumResultsForSearch: -1,
        width: "100%"
      });
    }
    // Multiselect
    if ($("#customleave_select").length > 0) {
      $("#customleave_select").multiselect();
    }
    if ($("#edit_customleave_select").length > 0) {
      $("#edit_customleave_select").multiselect();
    }

    if ($(".floating").length > 0) {
      $(".floating")
        .on("focus blur", function(e) {
          $(this)
            .parents(".form-focus")
            .toggleClass(
              "focused",
              e.type === "focus" || this.value.length > 0
            );
        })
        .trigger("blur");
    }
  },
  name: "summary_"
};
</script>


// WEBPACK FOOTER //
// src/views/agent/statisticMonthly.vue